import React from "react";
import { Marker, Polygon, Tooltip, useMap } from "react-leaflet";
import { getSVGIcon } from "./helper";
import "leaflet/dist/leaflet.css";
import { MarkerPopup, Pillar04AccountingPopup } from "./LayersHelpers";
import { useSelector } from "react-redux";






export const LayerPowerPlants = props => {
    const map = useMap();
    const zoom = map.getZoom()
    const { powerPlants } = useSelector(
        (state) => state.state.electricity
    );


    if (!powerPlants) {
        return <></>
    }

    const markers = powerPlants.map(mark => {
        if (!mark.x_y_coord || mark.x_y_coord === "") {
            return null;
        }

        return (
            <Marker
                position={[
                    mark.x_y_coord.split(' ')[1],
                    mark.x_y_coord.split(' ')[0],
                ]}
                icon={getSVGIcon('powerPlant', zoom > 14 ? {
                                    text: mark.name
                                } : null)}
                key={mark.fid}
                data={mark.fid}
                type={mark.type}
                pane="otherPane"
            >
                <Tooltip
                    direction="top"
                    key={`${mark.fid}_tooltip`}


                >{mark.name}
                </Tooltip>
                <MarkerPopup host={mark} key={`popup_${mark.fid}`} />
              
                {
                    zoom > 14 ?
                        <Polygon
                            positions={mark.coordinates}
                            fillColor="#8CB9D7"
                            fillOpacity={0.7}
                            color="#1E77B3"
                            key={`${mark.fid}_polygon`}
                        />
                        : null
                }

            </Marker>



        );
    }).filter(Boolean);
    return markers;
}